module.exports = __webpack_public_path__ + "b12459dbb66471a9875440a6f03bf6c2.svg";